export default "__VITE_ASSET__Cwk$IL1o__"